export default "__VITE_ASSET__DOdKVxNf__"